export enum GameStatus {
  scheduled = 'Scheduled',
  Pending = 'Pending',
  InProgress = 'In Progress',
  InReview = 'In Review',
  Completed = 'Completed',
}
